import { useEffect, useRef } from "react";
import { getCurrentTimePosition } from "@/lib/calendar-utils";

export function useAutoScroll(currentTime: Date, enabled: boolean = true) {
  const containerRef = useRef<HTMLDivElement>(null);
  const hasScrolledRef = useRef(false);

  useEffect(() => {
    if (!containerRef.current || !enabled || hasScrolledRef.current) return;

    // Calculate position based on current time
    const scrollPosition = getCurrentTimePosition(currentTime);

    // Scroll to position with current time line roughly in upper third
    const containerHeight = containerRef.current.clientHeight;
    const targetScroll = scrollPosition - containerHeight / 3;

    containerRef.current.scrollTo({
      top: Math.max(0, targetScroll),
      behavior: "smooth",
    });

    hasScrolledRef.current = true;
  }, [currentTime, enabled]);

  // Reset scroll flag when time changes significantly (e.g., new day)
  useEffect(() => {
    const checkReset = () => {
      const now = new Date();
      if (
        now.getDate() !== currentTime.getDate() ||
        now.getMonth() !== currentTime.getMonth()
      ) {
        hasScrolledRef.current = false;
      }
    };

    const interval = setInterval(checkReset, 60000);
    return () => clearInterval(interval);
  }, [currentTime]);

  return containerRef;
}
